export default "__VITE_ASSET__BXi2JzJ7__"